@if (facade.latestCategoryReport.isLoading()) {
    <div class="tw-grid tw-place-items-center tw-p-16">
        <sona-spinner />
    </div>
} @else {
    <section id="scores" class="tw-flex tw-flex-col tw-gap-6">
        <sona-score-card [score]="totalScore()" />
    </section>
    <section id="history">
        <div class="tw-grid sm:tw-grid-cols-2 tw-gap-6">
            <sona-score-history-card
                [group]="historyChartGroup"
                [history]="history()"
                [chartLength]="chartLength()"
            />
            <sona-page-history-card
                [history]="history()"
                [currentValue]="totalPages()"
                [group]="historyChartGroup"
                [chartLength]="chartLength()"
            />
            <sona-issue-history-card
                [history]="history()"
                [currentValue]="issues()"
                [group]="historyChartGroup"
                [chartLength]="chartLength()"
            />
        </div>
    </section>
    <section id="tables" class="tw-grid tw-gap-6">
        <sona-issue-table-card
            [scanRequestId]="facade.latestCategoryReport.value()?.id"
            [category]="category()"
            [count]="issuesResource.value()?.meta?.totalItems"
            [data]="issuesResource.value()?.data"
            [(sorting)]="issuesSorting"
        />
        <sona-page-table-card
            [scanRequestId]="facade.latestCategoryReport.value()?.id"
            [category]="category()"
            [count]="pagesResource.value()?.meta?.totalItems"
            [data]="pagesResource.value()?.data"
            [(sorting)]="pagesSorting"
        />
    </section>
}